unable to read source [project]/nextapp/node_modules/googleapis/node_modules/google-logging-utils/src/colours.ts